// opervex-frontend/src/pages/Home.js

import { Container, Row } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";

const Home = () => {
  const { loadingGlobal } = useAuth();

  if (loadingGlobal) return <div>Carregando...</div>;

  return (
    <>
      <Container>
        <Row>
          <h1 className=" text-center">Bem-vindo ao Opervex!</h1>
        </Row>

        <br />

        <Row>
          <h5 className="fw-light text-center">
            Gerencie seus produtos, serviços, lançamentos e relatórios de forma fácil e eficiente.
          </h5>
        </Row>
      </Container>
    </>
  );
};

export default Home;
